import * as React from 'react'

function SvgPrint(props: React.SVGProps<SVGSVGElement>) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="1.125em"
			height="1em"
			{...props}
		>
			<path
				fill="currentColor"
				d="M4.09 3.2h10.637V0H4.091zm10.637 4c0-.44.366-.8.813-.8a.81.81 0 01.814.8c0 .44-.366.8-.814.8a.809.809 0 01-.813-.8zm-9 2.4h7.364v4.8H5.727zM2.7 4.8C1.206 4.8 0 5.954 0 7.385v5.169h3.6V16h10.8v-3.446H18v-5.17c0-1.43-1.206-2.584-2.7-2.584z"
			/>
		</svg>
	)
}

export default SvgPrint
